import React from 'react';

import useAccounting from './accounting-hooks';
import AccountingScene from './accounting-scene';

const Accounting = () => {
  const {
    accounting,
    handleDeleteLedgerItem,
    t,
    handleDeleteLedgerParty,
    resolver,
    handledeleteLink,
    state,
    dispatch,
    handleReviseOrderLedger,
    loadingRevise,
    handleUpdateAccounting
  } = useAccounting();

  return (
    <AccountingScene
      accountingData={accounting || []}
      t={t}
      handleDeleteLedgerItem={handleDeleteLedgerItem}
      handleDeleteLedgerParty={handleDeleteLedgerParty}
      resolver={resolver}
      handledeleteLink={handledeleteLink}
      state={state}
      dispatch={dispatch}
      handleReviseOrderLedger={handleReviseOrderLedger}
      loadingRevise={loadingRevise}
      handleUpdateLedger={handleUpdateAccounting}
    />
  );
};

export default Accounting;
